/*
 * Change class built for executing custom code
 * @module
 */

var _ = require('optimizely-client-fn');
var deferred = require('core/utils/deferred');
var enums = require('core/action/enums');
var Exec = require('core/exec');

/**
 * @constructor
 *
 * @param {Change} change
 * @param {ChangeConfig} config
 * @throws {Error} if misconfigured.
 */
function CustomCodeChange (change:Change, config:ChangeConfig) {
  if (!_.isFunction(change.value)) {
    throw new Error('Custom code must be a function');
  }
  this.change = change;
}

/**
 * Apply custom code by executing supplied function
 * @returns {Deferred}
 */
CustomCodeChange.prototype.apply = function (): Deferred {
  var d = deferred();
  try {
    Exec.apply(this.change.value);
    d.resolve();
  } catch (e) {
    d.reject(e);
  }
  return d;
};

if (__UNDO_CHANGES_UPON_VIEW_DEACTIVATION__ || __TEST__) {
  /**
   * Undoes changes -- essentially a no-op for custom code since we dont know how to undo it
   * As such, we only want to run it once (as far as the instance of the change applier is concerned),
   * so resolve its undo status with IGNORE so that it doesnt get run again.
   * @returns {Deferred}
   */
  CustomCodeChange.prototype.undo = function (): Deferred {
    return deferred().resolve(enums.changeState.IGNORED);
  };
}

/**
 * PluginManager registration method
 * @param {PluginManager} PluginManager
 */
module.exports = function(PluginManager:PluginManagerClass) {
  PluginManager.registerChangeApplier(enums.changeType.CUSTOM_CODE, CustomCodeChange);
};

if (__TEST__) {
  module.exports.plugin = CustomCodeChange;
}
